export const JWT_TOKEN = "JwtToken";
export const JWT_REFRESH_TOKEN = "JwtRefreshToken";
export const REFRESH_TOKEN_CONST = "RefreshToken";
export const LANGUAGE = "Language";
